export const FETCH_SUPPORT_CATEGORIES_REQUEST = 'FETCH_SUPPORT_CATEGORIES_REQUEST';
export const FETCH_SUPPORT_CATEGORIES_SUCCESS = 'FETCH_SUPPORT_CATEGORIES_SUCCESS';
export const FETCH_SUPPORT_CATEGORIES_FAILURE = 'FETCH_SUPPORT_CATEGORIES_FAILURE';

export const FETCH_SUPPORT_ARTICLES_REQUEST = 'FETCH_SUPPORT_ARTICLES_REQUEST';
export const FETCH_SUPPORT_ARTICLES_SUCCESS = 'FETCH_SUPPORT_ARTICLES_SUCCESS';
export const FETCH_SUPPORT_ARTICLES_FAILURE = 'FETCH_SUPPORT_ARTICLES_FAILURE';

export const FETCH_SUPPORT_SEARCH_REQUEST = 'FETCH_SUPPORT_SEARCH_REQUEST';
export const FETCH_SUPPORT_SEARCH_SUCCESS = 'FETCH_SUPPORT_SEARCH_SUCCESS';
export const FETCH_SUPPORT_SEARCH_FAILURE = 'FETCH_SUPPORT_SEARCH_FAILURE';
export const CLEAR_SUPPORT_SEARCH = 'CLEAR_SUPPORT_SEARCH';

export const FETCH_SUPPORT_TAGS_REQUEST = 'FETCH_SUPPORT_TAGS_REQUEST';
export const FETCH_SUPPORT_TAGS_SUCCESS = 'FETCH_SUPPORT_TAGS_SUCCESS';
export const FETCH_SUPPORT_TAGS_FAILURE = 'FETCH_SUPPORT_TAGS_FAILURE';
